class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = theme.utils.debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.onInputChange.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) {
      facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }

    this.addEventListener('click', this.onPriceRangeApply.bind(this));
    this.setupDrawerOverlayClose();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;

      if (searchParams === FacetFiltersForm.searchParamsPrev) return;

      FacetFiltersForm.renderPage(searchParams, null, false);
    };

    FacetFiltersForm.renderProductPerPage();
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;

    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerMobile = document.getElementById('ProductCountMobile');

    const loadingSpinners = document.querySelectorAll(
      '.product-count .loading__spinner, .product-grid-container .loading__spinner'
    );

    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));

    document.getElementById('ProductGridContainer')
      .querySelector('.collection')
      .classList.add('loading');

    if (countContainer) countContainer.classList.add('loading');
    if (countContainerMobile) countContainerMobile.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(searchParams);
    }
  }

  static async renderSectionFromFetch(url, event) {
    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error('Caricamento filtri non riuscito');
      }

      const html = await response.text();

      FacetFiltersForm.filterData.push({ html, url });
      await FacetFiltersForm.renderResult(html, url, event);
    } catch (error) {
      FacetFiltersForm.showFilterError(url);
    }
  }

  static async renderSectionFromCache(filterDataUrl, event) {
    const entry = FacetFiltersForm.filterData.find(filterDataUrl);

    try {
      await FacetFiltersForm.renderResult(entry.html, entry.url, event);
    } catch (error) {
      FacetFiltersForm.showFilterError(entry.url);
    }
  }

  static onlySoldOut(searchParams) {
    const values = new URLSearchParams(searchParams)
      .getAll('filter.v.availability');

    return values.includes('0') && !values.includes('1');
  }

  static async prepareSoldOut(html, url) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const container = parsed.getElementById('ProductGridContainer');

    if (!container || !container.hasAttribute('data-paciocco-pages')) {
      throw new Error('Aggiornare anche main-collection-product-grid.liquid');
    }

    const pages = Number(container.dataset.pacioccoPages) || 1;
    const currentPage = Number(container.dataset.pacioccoPage) || 1;
    const documents = new Map([[currentPage, parsed]]);

    const missing = Array.from(
      { length: pages },
      (_, i) => i + 1
    ).filter(page => page !== currentPage);

    for (let i = 0; i < missing.length; i += 4) {
      await Promise.all(
        missing.slice(i, i + 4).map(async page => {
          const pageURL = new URL(url, window.location.origin);
          pageURL.searchParams.set('page', page);

          const response = await fetch(pageURL.toString());

          if (!response.ok) {
            throw new Error('Pagina filtri non caricata');
          }

          documents.set(
            page,
            new DOMParser().parseFromString(
              await response.text(),
              'text/html'
            )
          );
        })
      );
    }

    const items = [];
    const seen = new Set();

    Array.from(documents.keys())
      .sort((a, b) => a - b)
      .forEach(page => {
        documents.get(page)
          .querySelectorAll('#product-grid > .product-grid__item')
          .forEach(item => {
            if (!item.hasAttribute('data-paciocco-available')) {
              throw new Error('Metadati disponibilita mancanti');
            }

            if (
              item.dataset.pacioccoAvailable === 'false' &&
              !seen.has(item.dataset.productId)
            ) {
              seen.add(item.dataset.productId);
              items.push(item);
            }
          });
      });

    const grid = container.querySelector('#product-grid');

    if (grid) grid.replaceChildren(...items);

    container.querySelectorAll(
      '[data-paciocco-pagination], infinite-scroll, load-more-button'
    ).forEach(node => node.remove());

    if (!items.length && grid) {
      const message = parsed.createElement('p');

      message.textContent =
        'Nessun prodotto completamente esaurito corrisponde ai filtri selezionati.';

      grid.before(message);
    }

    const count = parsed.getElementById('ProductCount');

    if (count) {
      count.textContent = items.length + (
        items.length === 1
          ? ' prodotto esaurito'
          : ' prodotti esauriti'
      );
    }

    return parsed.documentElement.outerHTML;
  }

  static async renderResult(html, url, event) {
    const requestParams = new URL(url, window.location.origin).searchParams;
    requestParams.delete('section_id');

    const currentParams = new URLSearchParams(
      FacetFiltersForm.searchParamsPrev
    );

    requestParams.sort();
    currentParams.sort();

    if (requestParams.toString() !== currentParams.toString()) return;

    const expected = FacetFiltersForm.searchParamsPrev;

    if (FacetFiltersForm.onlySoldOut(requestParams.toString())) {
      html = await FacetFiltersForm.prepareSoldOut(html, url);
    }

    if (expected !== FacetFiltersForm.searchParamsPrev) return;

    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.normalizeAvailabilityLabels();
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderProductPerPage();
    FacetFiltersForm.clickGridView(html);

    if (typeof initializeScrollAnimationTrigger === 'function') {
      initializeScrollAnimationTrigger(html);
    }
  }

  static showFilterError(url) {
    const requested = new URL(url, window.location.origin);
    requested.searchParams.delete('section_id');

    if (
      requested.searchParams.toString() !==
      FacetFiltersForm.searchParamsPrev
    ) {
      return;
    }

    const container = document.getElementById('ProductGridContainer');
    if (!container) return;

    const message = document.createElement('p');

    message.setAttribute('role', 'alert');
    message.textContent =
      'Non riusciamo a caricare i risultati. Ricarica la pagina per riprovare.';

    container.replaceChildren(message);

    document.querySelectorAll(
      '.product-count .loading__spinner'
    ).forEach(node => node.classList.add('hidden'));
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML =
      new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('ProductGridContainer').innerHTML;

    document.getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    if (typeof initMoreSwatchButtons === 'function') {
      const container = document.getElementById('ProductGridContainer');
      initMoreSwatchButtons(container || document);
    }
  }

  static clickGridView(event) {
    document.querySelectorAll('.button--grid-view').forEach((button) => {
      button.addEventListener('click', this.changeLayoutGrid.bind(this));
    });
  }

  static changeLayoutGrid(event) {
    const gridView = event.currentTarget.dataset.grid;

    document.querySelectorAll('.button--grid-view').forEach((button) => {
      button.classList.add('cursor-pointer');
      button.classList.remove('active');
    });

    event.currentTarget.classList.remove('cursor-pointer');
    event.currentTarget.classList.add('active');

    document.querySelector(
      '.product-grid-container .product-grid'
    ).setAttribute('data-view', gridView);
  }

  static renderProductPerPage() {
    const productGrid = document.querySelector(
      '.product-grid-container .product-grid'
    );

    document.querySelectorAll('input[name="per_page"]').forEach(function(input) {
      input.addEventListener('change', function() {
        const detailsList = input.closest('.details__list');

        const currentSelected = detailsList
          ? detailsList.querySelector('.selected')
          : null;

        if (currentSelected) {
          currentSelected.classList.remove(
            'selected',
            'pointer-events-none'
          );
        }

        const currentItem = input.closest('.facet-filters__sort_item');

        if (currentItem) {
          currentItem.classList.add('selected', 'pointer-events-none');
        }

        const labelText = input.closest('details')
          ? input.closest('details').querySelector('.label-text')
          : null;

        if (labelText) labelText.innerHTML = this.value;

        if (detailsList) {
          detailsList.querySelectorAll('input[name="per_page"]')
            .forEach((other) => {
              if (other !== input) other.checked = false;
            });

          detailsList.querySelectorAll('.facet-filters__sort_item')
            .forEach((li) => {
              if (li !== currentItem) {
                li.classList.remove('selected', 'pointer-events-none');
              }
            });
        }

        const data = new URLSearchParams();
        data.append('attributes[pagination]', this.value);

        fetch('/cart/update.js', {
          method: 'POST',
          body: data,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
          .then((response) => response.text())
          .finally(() => {
            FacetFiltersForm.renderPage(
              window.location.search.slice(1),
              null,
              false
            );
          });
      });
    });

    if (productGrid) {
      const gridViewButton = document.querySelector(
        '.button--grid-view.active'
      );

      if (gridViewButton) {
        productGrid.setAttribute(
          'data-view',
          gridViewButton.dataset.grid
        );
      }
    }
  }

  static renderProductCount(html) {
    const countNode = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductCount');

    const count = countNode ? countNode.innerHTML : '0 prodotti';
    const container = document.getElementById('ProductCount');
    const containerMobile = document.getElementById('ProductCountMobile');

    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }

    if (containerMobile) {
      containerMobile.innerHTML = count;
      containerMobile.classList.remove('loading');
    }

    document.querySelectorAll(
      '.product-count .loading__spinner'
    ).forEach((spinner) => spinner.classList.add('hidden'));
  }

  static normalizeAvailabilityLabels(root = document) {
    root.querySelectorAll(
      'details[id*="filter.v.availability"] label'
    ).forEach(label => {
      const walker = document.createTreeWalker(
        label,
        NodeFilter.SHOW_TEXT
      );

      while (walker.nextNode()) {
        const node = walker.currentNode;

        const cleaned = node.nodeValue.replace(
          /\s*\(\s*\d[\d.,\s]*\s+prodott[oi]\s*\)/gi,
          ''
        );

        if (cleaned !== node.nodeValue) {
          node.nodeValue = cleaned;
        }
      }
    });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (
        !currentElement.hasAttribute('data-paciocco-size-fallback') &&
        !Array.from(facetDetailsElementsFromFetch).some(
          ({ id }) => currentElement.id === id
        )
      ) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event
        ? event.target.closest('.js-filter')
        : undefined;

      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(
      facetDetailsElementsFromFetch
    ).filter((element) => !matchesId(element));

    const countsToRender = Array.from(
      facetDetailsElementsFromFetch
    ).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);

      if (currentElement) {
        currentElement.innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const {
            className: previousElementClassName,
            id: previousElementId
          } = facetsToRender[index - 1];

          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          const parent = document.getElementById(
            elementToRender.parentElement.id
          );

          const sibling = parent?.querySelector('.js-filter');

          if (sibling) sibling.before(elementToRender);
          else if (parent) parent.appendChild(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest('.js-filter')
        );

        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID)
        );

        const newFacetDetailsElement = document.getElementById(
          closestJSFilterID
        );

        const newElementSelector =
          newFacetDetailsElement.classList.contains('mobile-facets__details')
            ? '.mobile-facets__close-button'
            : '.facets__summary';

        const newElementToActivate =
          newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) {
          newElementToActivate.focus();
        }
      }
    }
  }

  static renderActiveFacets(html) {
    const selectors = [
      '.active-facets-mobile',
      '#FacetsWrapperDesktop',
      '.active-facets-desktop'
    ];

    selectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);

      if (!activeFacetsElement) return;

      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const selectors = [
      '.mobile-facets__open',
      '.mobile-facets__count',
      '.sorting'
    ];

    selectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;

      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile')
      .closest('menu-drawer')
      .bindEvents();

    const facetFiltersForm = document.querySelector('facet-filters-form');

    if (facetFiltersForm) {
      facetFiltersForm.setupDrawerOverlayClose();
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector('show-more-button .label-show-more.hidden')
      );

      if (isShowingMore) {
        sourceWrapElement.querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => {
            hiddenItem.classList.replace('hidden', 'show-more-item');
          });
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id
      }
    ];
  }

  createSearchParams(form, applyPrice = false) {
    const formData = new FormData(form);
    const activeParams = new URLSearchParams(window.location.search);

    ['filter.v.price.gte', 'filter.v.price.lte'].forEach((name) => {
      const input = form.querySelector('input[name="' + name + '"]');

      const value = applyPrice && input
        ? input.value.trim()
        : activeParams.get(name);

      formData.delete(name);

      if (value !== null && value !== '') {
        const price = Number(String(value).replace(',', '.'));

        if (Number.isFinite(price) && price >= 0) {
          formData.set(name, String(price));
        }
      }
    });

    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const sortFilterForms = document.querySelectorAll(
      'facet-filters-form form'
    );

    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(
        event.target.closest('form')
      );

      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];

      const isMobile =
        event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === 'FacetSortForm' ||
            form.id === 'FacetFiltersForm' ||
            form.id === 'FacetSortDrawerForm'
          ) {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });

      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onInputChange(event) {
    const isPriceRangeInput =
      event.target.classList.contains('filter__price_change') ||
      event.target.classList.contains('filter__price_number');

    if (!isPriceRangeInput) {
      this.debouncedOnSubmit(event);
    }
  }

  onPriceRangeApply(event) {
    if (event.target.closest('.facets-price__apply button')) {
      event.preventDefault();

      const form = event.target.closest('form');

      if (form) {
        const searchParams = this.createSearchParams(form, true);
        this.onSubmitForm(searchParams, event);
      }
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    FacetFiltersForm.toggleActiveFacets();

    const url = event.currentTarget.href.indexOf('?') == -1
      ? ''
      : event.currentTarget.href.slice(
          event.currentTarget.href.indexOf('?') + 1
        );

    FacetFiltersForm.renderPage(url);

    if (window.innerWidth <= 1024) {
      document.querySelectorAll('.mobile-facets__details').forEach(item => {
        item.removeAttribute('style');
        item.removeAttribute('open');
      });
    }
  }

  setupDrawerOverlayClose() {
    const drawerOverlay = this.querySelector('[data-drawer-overlay]');

    if (drawerOverlay) {
      drawerOverlay.addEventListener('click', (event) => {
        event.preventDefault();
        this.closeDrawer();
      });
    }
  }

  closeDrawer() {
    const closeButton = this.querySelector('[data-close-drawer]');

    if (closeButton) {
      closeButton.click();
      document.body.classList.remove('overflow-hidden-mobile');
    } else {
      const menuDrawer = this.closest('menu-drawer');

      if (menuDrawer) {
        const details = menuDrawer.querySelector('details');

        if (details && details.hasAttribute('open')) {
          details.removeAttribute('open');
          document.body.classList.remove('overflow-hidden-mobile');
        }
      }
    }
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);

if (!customElements.get('facet-filters-form')) {
  customElements.define('facet-filters-form', FacetFiltersForm);
}

FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.sliders = Array.from(
      this.querySelectorAll('.filter__price_change')
    );

    this.fields = ['filter.v.price.gte', 'filter.v.price.lte'].map((name) => {
      return this.querySelector('input[name="' + name + '"]');
    });

    if (this.fields.some((field) => !field)) return;

    const params = new URLSearchParams(window.location.search);

    this.fields.forEach((field) => {
      field.value = params.get(field.name) || '';
      field.defaultValue = field.value;

      field.placeholder = field.name.endsWith('.gte')
        ? 'Minimo'
        : 'Massimo';

      field.addEventListener('input', () => this.syncSliders());
    });

    this.sliders.forEach((slider, index) => {
      slider.addEventListener('input', () => {
        const other = this.sliders[1 - index];

        if (other) {
          if (index === 0 && Number(slider.value) > Number(other.value)) {
            other.value = slider.value;
          }

          if (index === 1 && Number(slider.value) < Number(other.value)) {
            other.value = slider.value;
          }
        }

        this.sliders.forEach((item, i) => {
          if (this.fields[i]) {
            this.fields[i].value = item.value;
          }
        });

        this.updateDisplay();
      });
    });

    this.syncSliders();
  }

  syncSliders() {
    this.sliders.forEach((slider, index) => {
      const field = this.fields[index];
      const raw = field ? field.value.trim() : '';
      const number = Number(raw.replace(',', '.'));
      const min = Number(slider.min) || 0;
      const max = Number(slider.max);

      slider.value = raw !== '' && Number.isFinite(number)
        ? Math.max(min, Math.min(max, number))
        : (index === 0 ? min : max);
    });

    this.updateDisplay();
  }

  updateDisplay() {
    const track = this.querySelector('.facets-price__range');

    if (!track || this.sliders.length < 2) return;

    const max = Number(this.sliders[1].max);
    if (!(max > 0)) return;

    const width = track.clientWidth;

    track.style.setProperty(
      '--left-space',
      Number(this.sliders[0].value) / max * width + 'px'
    );

    track.style.setProperty(
      '--right-space',
      width - Number(this.sliders[1].value) / max * width + 'px'
    );
  }
}

if (!customElements.get('price-range')) {
  customElements.define('price-range', PriceRange);
}

class FacetRemove extends HTMLElement {
  constructor() {
    super();

    const facetLink = this.querySelector('a');

    facetLink.setAttribute('role', 'button');

    facetLink.addEventListener(
      'click',
      this.closeFilter.bind(this)
    );

    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();

      if (event.code.toUpperCase() === 'SPACE') {
        this.closeFilter(event);
      }
    });
  }

  closeFilter(event) {
    event.preventDefault();

    const form = this.closest('facet-filters-form')
      || document.querySelector('facet-filters-form');

    form.onActiveFilterClick(event);
  }
}

if (!customElements.get('facet-remove')) {
  customElements.define('facet-remove', FacetRemove);
}

/* Colori testuali nei filtri, senza modificare le schede prodotto. */
if (!document.getElementById('paciocco-facet-color-text')) {
  const style = document.createElement('style');

  style.id = 'paciocco-facet-color-text';
  style.textContent =
    'facet-filters-form details[id*="filter.v.option.colore"] .swatch { display: none !important; }';

  document.head.appendChild(style);
}

if (
  !window.location.pathname.includes('/collections/') &&
  FacetFiltersForm.onlySoldOut(window.location.search)
) {
  const refreshSoldOut = () => {
    FacetFiltersForm.renderPage(
      window.location.search.slice(1),
      null,
      false
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshSoldOut, {
      once: true
    });
  } else {
    refreshSoldOut();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => FacetFiltersForm.normalizeAvailabilityLabels(),
    { once: true }
  );
} else {
  FacetFiltersForm.normalizeAvailabilityLabels();
}

/* Taglie unificate: mantiene gli altri filtri e l'ordinamento. */
(() => {
  if (!window.location.pathname.includes('/collections/')) return;

  const names = [
    'filter.v.option.taglia',
    'filter.v.option.numero di scarpa'
  ];

  const canonical = names[0];
  const cache = new Map();

  let revision = 0;

  const originalRender = FacetFiltersForm.renderResult.bind(
    FacetFiltersForm
  );

  const normalize = value => String(value).trim();

  const selectedSizes = params => [
    ...new Set(
      names.flatMap(name => params.getAll(name)).map(normalize)
    )
  ];

  const readSizes = item => {
    if (!item.hasAttribute('data-paciocco-sizes')) {
      throw new Error('Installare anche la sezione taglie unificate');
    }

    const values = JSON.parse(item.dataset.pacioccoSizes);

    if (!Array.isArray(values)) {
      throw new Error('Taglie non valide');
    }

    return values.map(normalize);
  };

  function matchesSelectedVariants(item, selected, params) {
    if (!item.hasAttribute('data-paciocco-variants')) {
      throw new Error(
        'Aggiornare la sezione collezione alla versione varianti v4'
      );
    }

    const variants = JSON.parse(item.dataset.pacioccoVariants);

    if (
      !Array.isArray(variants) ||
      variants.some(variant =>
        !variant ||
        !Array.isArray(variant.sizes) ||
        typeof variant.matched !== 'boolean' ||
        typeof variant.available !== 'boolean'
      )
    ) {
      throw new Error('Dati varianti non validi');
    }

    const availability = params
      .getAll('filter.v.availability')
      .flatMap(value => value.split(','));

    const availableOnly =
      availability.includes('1') && !availability.includes('0');

    const soldOutOnly =
      availability.includes('0') && !availability.includes('1');

    return variants.some(variant =>
      variant.matched &&
      variant.sizes.some(size => selected.includes(normalize(size))) &&
      (!availableOnly || variant.available) &&
      (!soldOutOnly || !variant.available)
    );
  }

  async function getPages(url) {
    const key = url.toString();

    if (cache.has(key)) return cache.get(key);

    const promise = (async () => {
      const fetchPage = async page => {
        const target = new URL(url);
        target.searchParams.set('page', String(page));

        const response = await fetch(target, {
          credentials: 'same-origin'
        });

        if (!response.ok) {
          throw new Error('Caricamento taglie non riuscito');
        }

        return new DOMParser().parseFromString(
          await response.text(),
          'text/html'
        );
      };

      const first = await fetchPage(1);

      const container = first.getElementById('ProductGridContainer');

      if (!container || !container.hasAttribute('data-paciocco-pages')) {
        throw new Error('Sezione non aggiornata');
      }

      const count = Math.max(
        1,
        Number(container.dataset.pacioccoPages) || 1
      );

      const docs = [first];

      for (let page = 2; page <= count; page += 3) {
        docs.push(
          ...await Promise.all(
            Array.from(
              { length: Math.min(3, count - page + 1) },
              (_, i) => fetchPage(page + i)
            )
          )
        );
      }

      return docs;
    })();

    cache.set(key, promise);

    if (cache.size > 5) {
      cache.delete(cache.keys().next().value);
    }

    try {
      return await promise;
    } catch (error) {
      cache.delete(key);
      throw error;
    }
  }

  function ensureSizeFacet(form, sizes) {
    const existing = [
      ...form.querySelectorAll('.js-filter')
    ].filter(node => names.some(name => node.id.includes(name)));

    if (existing.length) return existing;
    if (!sizes.length) return [];

    const mobile = form.id === 'FacetFiltersFormMobile';

    const template = [
      ...form.querySelectorAll('details.js-filter')
    ].find(node =>
      node.id.includes('filter.v.availability') &&
      node.querySelector('input[type="checkbox"]')
    );

    let facet;

    if (template) {
      facet = template.cloneNode(true);

      const replacements = new Map();

      [facet, ...facet.querySelectorAll('[id]')].forEach((node, index) => {
        replacements.set(
          node.id,
          'paciocco-fallback-' + form.id + '-' + index
        );

        node.id = replacements.get(node.id);
      });

      facet.querySelectorAll(
        '[for], [aria-controls], [aria-labelledby]'
      ).forEach(node => {
        ['for', 'aria-controls', 'aria-labelledby'].forEach(attr => {
          if (node.hasAttribute(attr)) {
            node.setAttribute(
              attr,
              node.getAttribute(attr)
                .split(' ')
                .map(id => replacements.get(id) || id)
                .join(' ')
            );
          }
        });
      });

      const title = facet.querySelector(
        'summary .facets__label, summary > div > span'
      );

      if (title) title.firstChild.textContent = 'Taglia';

      facet.querySelectorAll('legend').forEach(node => {
        node.textContent = 'Taglia';
      });

      facet.querySelector('summary')?.setAttribute(
        'aria-label',
        'Taglia'
      );
    } else {
      facet = document.createElement('details');

      facet.className = mobile
        ? 'mobile-facets__details js-filter'
        : 'facets__panel facets__disclosure js-filter';

      const summary = document.createElement('summary');

      summary.className = mobile
        ? 'mobile-facets__summary'
        : 'facets__summary';

      summary.textContent = 'Taglia';

      const panel = document.createElement('div');

      panel.className = mobile
        ? 'mobile-facets__submenu details-content'
        : 'facets__display';

      const list = document.createElement('ul');

      list.className = mobile
        ? 'mobile-facets__list list-unstyled'
        : 'facets__list list-unstyled';

      const li = document.createElement('li');
      const label = document.createElement('label');
      const input = document.createElement('input');

      input.type = 'checkbox';

      label.append(input);
      li.append(label);
      list.append(li);
      panel.append(list);
      facet.append(summary, panel);
    }

    facet.id = 'Details-' + form.id + '-' + canonical + '-paciocco';
    facet.dataset.pacioccoSizeFallback = '';
    facet.dataset.index = mobile
      ? 'mobile-paciocco-size'
      : 'paciocco-size';

    facet.removeAttribute('open');

    facet.querySelector('summary')?.setAttribute(
      'aria-expanded',
      'false'
    );

    const anchor = form.querySelector('details.js-filter');

    if (anchor) {
      anchor.after(facet);
    } else {
      const host = mobile
        ? form.querySelector('.mobile-facets__inner')
        : form.querySelector('#FacetsWrapperDesktop');

      if (!host) return [];

      host.append(facet);
    }

    return [facet];
  }

  function formatFilterChoices() {
    document.querySelectorAll(
      'facet-filters-form details[id*="filter.v.option.colore"]'
    ).forEach(details => {
      const list = details.querySelector(
        '.mobile-facets__list, .facets__list'
      );

      if (!list) return;

      list.dataset.pacioccoChoices = 'colors';

      [...list.children].forEach(item => {
        const original = item.querySelector('input[type="checkbox"]');

        if (!original) return;

        const oldLabel = [
          ...item.querySelectorAll('label')
        ].find(label => label.htmlFor === original.id);

        const caption =
          oldLabel?.getAttribute('title') ||
          item.querySelector('.facet-checkbox__text-label')
            ?.textContent.trim() ||
          oldLabel?.textContent.trim().replace(
            /\s*\(\s*\d[\d.,\s]*\s+prodott[oi]\s*\)/gi,
            ''
          );

        if (!caption) return;

        const input = original.cloneNode(true);

        input.checked = original.checked;
        input.defaultChecked = original.checked;

        input.className =
          details.classList.contains('mobile-facets__details')
            ? 'mobile-facets__checkbox'
            : '';

        input.setAttribute('aria-label', 'Colore: ' + caption);

        const label = document.createElement('label');

        label.className = 'paciocco-filter-choice';
        label.htmlFor = input.id;

        const text = document.createElement('span');

        text.className = 'paciocco-choice-text';
        text.textContent = caption;

        label.append(input, text);
        item.classList.remove('swatch-item');
        item.replaceChildren(label);
      });
    });

    document.querySelectorAll(
      '[data-paciocco-unified-sizes]'
    ).forEach(list => {
      list.dataset.pacioccoChoices = 'sizes';

      list.querySelectorAll('label').forEach(label => {
        const original = label.querySelector('input[type="checkbox"]');

        if (!original) return;

        const input = original.cloneNode(true);

        input.checked = original.checked;
        input.defaultChecked = original.checked;

        input.setAttribute('aria-label', 'Taglia ' + input.value);

        const text = document.createElement('span');

        text.className = 'paciocco-choice-text';
        text.textContent = input.value;

        label.className = 'paciocco-filter-choice';
        label.removeAttribute('style');
        label.replaceChildren(input, text);
      });
    });

    document.querySelectorAll(
      '[data-paciocco-size-badges] a'
    ).forEach(link => {
      const caption = link.textContent
        .replace(/\s*×\s*$/, '')
        .trim();

      const inner = document.createElement('span');
      inner.className = 'active-facets__button-inner';

      const text = document.createElement('span');
      text.textContent = caption;

      const close = document.createElement('span');
      close.className = 'svg-wrapper';
      close.setAttribute('aria-hidden', 'true');

      close.innerHTML =
        '<svg viewBox="0 0 12 12" width="12" height="12" fill="none"><path d="m3 3 6 6M9 3 3 9" stroke="currentColor" stroke-linecap="round"/></svg>';

      inner.append(text, close);
      link.replaceChildren(inner);
      link.setAttribute('aria-label', 'Rimuovi ' + caption);
    });
  }

  function decorate(sizes, selected, params) {
    document.querySelectorAll(
      'facet-filters-form form'
    ).forEach(form => {
      const details = ensureSizeFacet(form, sizes);

      if (!details.length) return;

      const primary = details.find(
        node => node.id.includes(canonical)
      ) || details[0];

      details.filter(node => node !== primary).forEach(node => {
        node.remove();
      });

      const list = primary.querySelector(
        '.mobile-facets__list, .facets__list'
      );

      if (!list) return;

      const labels = [...list.querySelectorAll('label')];

      const sample = labels.find(label =>
        label.querySelector('input[type="checkbox"]')
      );

      if (!sample) return;

      const fragment = document.createDocumentFragment();

      sizes.forEach((size, index) => {
        const label = sample.cloneNode(true);
        const input = label.querySelector('input');
        const id = 'paciocco-size-' + form.id + '-' + index;

        input.name = canonical;
        input.value = size;
        input.id = id;
        input.checked = selected.includes(size);
        input.defaultChecked = input.checked;
        input.disabled = false;
        input.removeAttribute('aria-describedby');

        label.htmlFor = id;
        label.classList.remove(
          'disabled',
          'facet-checkbox--disabled'
        );

        input.setAttribute('aria-label', 'Taglia ' + size);

        const text = label.querySelector(
          '.facet-checkbox__text-label'
        );

        if (text) {
          text.textContent = size;
        } else {
          label.querySelectorAll(
            'span:not(.svg-wrapper)'
          ).forEach(node => {
            if (!node.querySelector('svg')) node.remove();
          });

          const caption = document.createElement('span');
          caption.className = 'facet-checkbox__text';
          caption.textContent = size;
          label.appendChild(caption);
        }

        label.querySelectorAll('.visually-hidden').forEach(node => {
          node.textContent = 'Taglia ' + size;
        });

        label.querySelectorAll(
          '.facet-checkbox__text > span:not(.facet-checkbox__text-label)'
        ).forEach(node => node.remove());

        const li = document.createElement('li');

        li.className = sample.closest('li')?.className
          || 'list-menu__item facets__item';

        li.classList.remove('hidden', 'show-more-item');
        li.appendChild(label);
        fragment.appendChild(li);
      });

      list.dataset.pacioccoUnifiedSizes = '';
      list.replaceChildren(fragment);

      primary.querySelectorAll('show-more-button').forEach(node => {
        node.remove();
      });

      const summary = primary.querySelector('summary');

      if (summary) {
        summary.setAttribute(
          'aria-label',
          'Taglia (' + selected.length + ' selezionate)'
        );

        const bubble = summary.querySelector('.bubble');
        if (bubble) bubble.textContent = selected.length;

        const status = summary.querySelector('.facets__status');

        if (status) {
          status.classList.toggle('hidden', !selected.length);
        }
      }

      const resetParams = new URLSearchParams(params);

      names.forEach(name => resetParams.delete(name));
      resetParams.delete('page');

      primary.querySelectorAll('facet-remove a').forEach(link => {
        link.href = window.location.pathname + (
          resetParams.size ? '?' + resetParams : ''
        );
      });
    });

    if (selected.length) {
      document.querySelectorAll('facet-remove a').forEach(link => {
        const text = link.textContent
          .trim()
          .replace(/\s+/g, ' ')
          .toLowerCase();

        const ownSize = link.closest('details');

        if (/cancella tutt|rimuovi tutt|clear all/.test(text)) return;

        if (
          ownSize &&
          names.some(name => ownSize.id.includes(name))
        ) {
          return;
        }

        const target = new URL(
          link.getAttribute('href'),
          window.location.origin
        );

        if (
          target.origin !== window.location.origin ||
          target.pathname !== window.location.pathname
        ) {
          return;
        }

        names.forEach(name => target.searchParams.delete(name));
        target.searchParams.delete('page');

        selected.forEach(size => {
          target.searchParams.append(canonical, size);
        });

        link.href = target.pathname + (
          target.searchParams.size
            ? '?' + target.searchParams.toString()
            : ''
        );
      });
    }

    document.querySelectorAll(
      '[data-paciocco-size-badges]'
    ).forEach(node => node.remove());

    if (selected.length) {
      document.querySelectorAll(
        '.active-facets-mobile, .active-facets-desktop'
      ).forEach(host => {
        const wrapper = document.createElement('div');
        wrapper.dataset.pacioccoSizeBadges = '';

        selected.forEach(size => {
          const next = new URLSearchParams(params);

          names.forEach(name => next.delete(name));
          next.delete('page');

          selected.filter(value => value !== size).forEach(value => {
            next.append(canonical, value);
          });

          const remove = document.createElement('span');
          const link = document.createElement('a');

          link.href = window.location.pathname + (
            next.size ? '?' + next : ''
          );

          link.className = 'active-facets__button';
          link.textContent = 'Taglia: ' + size + ' ×';

          link.addEventListener('click', event => {
            event.preventDefault();

            FacetFiltersForm.renderPage(
              next.toString(),
              null,
              true
            );
          });

          remove.appendChild(link);
          wrapper.appendChild(remove);
        });

        host.appendChild(wrapper);
      });
    }

    if (selected.length) {
      document.querySelectorAll('.js-filter label').forEach(label => {
        const walker = document.createTreeWalker(
          label,
          NodeFilter.SHOW_TEXT
        );

        while (walker.nextNode()) {
          walker.currentNode.nodeValue =
            walker.currentNode.nodeValue.replace(
              /\s*\(\s*\d[\d.,\s]*\s+prodott[oi]\s*\)/gi,
              ''
            );
        }
      });
    }
  }

  FacetFiltersForm.renderPage = async function(
    searchParams,
    event,
    updateURLHash = true
  ) {
    const params = new URLSearchParams(searchParams);
    const selected = selectedSizes(params);

    names.forEach(name => params.delete(name));

    selected.forEach(size => {
      params.append(canonical, size);
    });

    params.delete('page');

    const canonicalParams = params.toString();
    FacetFiltersForm.searchParamsPrev = canonicalParams;

    const run = ++revision;

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(canonicalParams);
    }

    const container = document.getElementById(
      'ProductGridContainer'
    );

    if (!container) return;

    container.querySelector(
      '[data-paciocco-filter-error]'
    )?.remove();

    container.setAttribute('aria-busy', 'true');

    try {
      const base = new URL(
        window.location.pathname,
        window.location.origin
      );

      base.search = params.toString();

      names.forEach(name => base.searchParams.delete(name));

      base.searchParams.set(
        'section_id',
        FacetFiltersForm.getSections()[0].section
      );

      const docs = await getPages(base);

      if (run !== revision) return;

      const all = [];
      const seen = new Set();

      docs.forEach(doc => {
        doc.querySelectorAll(
          '#product-grid > .product-grid__item'
        ).forEach(item => {
          if (!seen.has(item.dataset.productId)) {
            seen.add(item.dataset.productId);
            readSizes(item);
            all.push(item);
          }
        });
      });

      const sizes = [
        ...new Set([...all.flatMap(readSizes), ...selected])
      ].sort((a, b) => a.localeCompare(b, 'it', { numeric: true }));

      const source = new DOMParser().parseFromString(
        docs[0].documentElement.outerHTML,
        'text/html'
      );

      const target = source.getElementById(
        'ProductGridContainer'
      );

      if (selected.length) {
        const matches = all.filter(item =>
          matchesSelectedVariants(item, selected, params)
        );

        const grid = target.querySelector('#product-grid');

        if (grid) {
          grid.replaceChildren(
            ...matches.map(item => item.cloneNode(true))
          );

          grid.dataset.infiniteScroll = 'false';
          grid.dataset.totalPages = '1';
          grid.dataset.currentPage = '1';
          grid.dataset.lastPage = '1';
          grid.dataset.totalItems = String(matches.length);

          target.querySelectorAll(
            '[ref="viewMorePrevious"], [ref="viewMoreNext"]'
          ).forEach(node => node.remove());

          grid.querySelectorAll(
            '.product-grid__item'
          ).forEach((item, index) => {
            item.hidden = index >= 24;
            item.dataset.page = '1';
          });

          target.querySelectorAll(
            '[data-paciocco-pagination], infinite-scroll, load-more-button, .pagination-wrapper'
          ).forEach(node => node.remove());

          target.querySelectorAll(
            'a[href*="page="]'
          ).forEach(node => node.remove());

          const count = source.getElementById('ProductCount');

          const countText = matches.length + (
            matches.length === 1 ? ' prodotto' : ' prodotti'
          );

          if (count) count.textContent = countText;

          source.querySelectorAll(
            '.mobile-facets__count'
          ).forEach(node => {
            node.textContent = countText;
          });

          if (!matches.length) {
            const empty = source.createElement('p');

            empty.textContent =
              'Nessun prodotto corrisponde alle taglie e ai filtri selezionati.';

            grid.after(empty);
          }

          if (matches.length > 24) {
            const button = source.createElement('button');

            button.type = 'button';
            button.textContent = 'Mostra altro';
            button.className = 'button';
            button.dataset.pacioccoSizeMore = '';

            grid.after(button);
          }
        }

        FacetFiltersForm.renderFilters(
          source.documentElement.outerHTML,
          null
        );

        FacetFiltersForm.renderProductGridContainer(
          source.documentElement.outerHTML
        );

        FacetFiltersForm.renderProductCount(
          source.documentElement.outerHTML
        );

        FacetFiltersForm.renderProductPerPage();
        FacetFiltersForm.clickGridView();
      } else {
        const request = new URL(base);

        request.search = params.toString();

        request.searchParams.set(
          'section_id',
          base.searchParams.get('section_id')
        );

        await originalRender(
          source.documentElement.outerHTML,
          request.toString(),
          null
        );
      }

      if (run !== revision) return;

      decorate(sizes, selected, params);
      formatFilterChoices();
      FacetFiltersForm.normalizeAvailabilityLabels();

      document.querySelector(
        '[data-paciocco-size-more]'
      )?.addEventListener('click', function() {
        const hidden = [
          ...document.querySelectorAll(
            '#product-grid > .product-grid__item[hidden]'
          )
        ];

        hidden.slice(0, 24).forEach(item => {
          item.hidden = false;
        });

        if (hidden.length <= 24) this.remove();
      });
    } catch (error) {
      if (run !== revision) return;

      console.error('Paciocco filtro taglie:', error);

      const notice = document.createElement('div');
      notice.dataset.pacioccoFilterError = '';

      const message = document.createElement('p');
      message.setAttribute('role', 'alert');

      message.textContent =
        'Non è stato possibile aggiornare i filtri. I prodotti mostrati sono quelli precedenti. Riprova.';

      const retry = document.createElement('button');

      retry.type = 'button';
      retry.className = 'button';
      retry.textContent = 'Riprova';

      retry.addEventListener('click', () => {
        window.location.reload();
      });

      notice.append(message, retry);
      container.prepend(notice);
    } finally {
      if (run === revision) {
        container.removeAttribute('aria-busy');
      }
    }
  };

  async function hydrateInitialSizes(params) {
    const run = revision;

    try {
      const applySizes = items => {
        const sizes = [
          ...new Set(items.flatMap(readSizes))
        ].sort((a, b) =>
          a.localeCompare(b, 'it', { numeric: true })
        );

        decorate(sizes, [], params);
        formatFilterChoices();
      };

      applySizes([
        ...document.querySelectorAll(
          '#product-grid > .product-grid__item'
        )
      ]);

      const container = document.getElementById(
        'ProductGridContainer'
      );

      if (Number(container?.dataset.pacioccoPages) <= 1) return;

      const base = new URL(
        window.location.pathname,
        window.location.origin
      );

      base.search = params.toString();
      base.searchParams.delete('page');

      base.searchParams.set(
        'section_id',
        FacetFiltersForm.getSections()[0].section
      );

      const docs = await getPages(base);

      if (run !== revision) return;

      applySizes(
        docs.flatMap(doc => [
          ...doc.querySelectorAll(
            '#product-grid > .product-grid__item'
          )
        ])
      );
    } catch (error) {
      console.warn(
        'Paciocco: completamento taglie iniziali non riuscito',
        error
      );
    }
  }

  const start = () => {
    if (
      !document.querySelector('facet-filters-form') ||
      !document.getElementById('ProductGridContainer')
    ) {
      return;
    }

    const style = document.createElement('style');

    style.textContent = `
      #product-grid > .product-grid__item[hidden] {
        display: none !important;
      }

      [data-paciocco-unified-sizes] > li {
        position: relative !important;
      }

      [data-paciocco-unified-sizes] label {
        position: relative !important;
      }

      [data-paciocco-unified-sizes] label:has(input:checked) {
        background: #111 !important;
        color: #fff !important;
      }

      [data-paciocco-unified-sizes] label:has(input:checked) .facet-checkbox__text,
      [data-paciocco-unified-sizes] label:has(input:checked) .facet-checkbox__text-label {
        background: #111 !important;
        color: #fff !important;
      }

      [data-paciocco-unified-sizes] label:has(input:focus-visible) {
        outline: 2px solid #111 !important;
        outline-offset: 3px;
      }

      [data-paciocco-unified-sizes] input[type=checkbox] {
        position: absolute !important;
        inset: 0 !important;
        width: 100% !important;
        height: 100% !important;
        margin: 0 !important;
        opacity: 0 !important;
        cursor: pointer !important;
        z-index: 1 !important;
      }

      [data-paciocco-size-badges] {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
      }

      [data-paciocco-size-more] {
        margin: 24px auto;
        display: block;
      }

      facet-filters-form [data-paciocco-choices] {
        display: grid !important;
        gap: 8px !important;
        padding: 4px 0 !important;
        margin: 0 !important;
        list-style: none !important;
        width: 100% !important;
        box-sizing: border-box !important;
      }

      facet-filters-form [data-paciocco-choices="colors"] {
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      }

      facet-filters-form [data-paciocco-choices="sizes"] {
        grid-template-columns: repeat(auto-fill, minmax(40px, 1fr)) !important;
      }

      facet-filters-form [data-paciocco-choices] > li {
        display: block !important;
        position: relative !important;
        min-width: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
      }

      facet-filters-form [data-paciocco-choices] label {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        position: relative !important;
        box-sizing: border-box !important;
        width: 100% !important;
        min-width: 0 !important;
        min-height: 44px !important;
        height: auto !important;
        margin: 0 !important;
        padding: 8px !important;
        border: 1px solid #bdbdbd !important;
        border-radius: 2px !important;
        background: #fff !important;
        color: #111 !important;
        box-shadow: none !important;
        font-size: 13px !important;
        line-height: 1.25 !important;
        text-align: center !important;
        cursor: pointer !important;
        user-select: none;
        -webkit-user-select: none;
      }

      facet-filters-form [data-paciocco-choices] label::before,
      facet-filters-form [data-paciocco-choices] label::after {
        content: none !important;
      }

      facet-filters-form [data-paciocco-choices] .paciocco-choice-text,
      facet-filters-form [data-paciocco-choices] .facet-checkbox__text,
      facet-filters-form [data-paciocco-choices] .facet-checkbox__text-label {
        position: static !important;
        display: block !important;
        width: auto !important;
        height: auto !important;
        padding: 0 !important;
        margin: 0 !important;
        border: 0 !important;
        border-radius: 0 !important;
        background: transparent !important;
        color: inherit !important;
        font-size: inherit !important;
        line-height: inherit !important;
        white-space: normal !important;
        overflow-wrap: anywhere;
        box-shadow: none !important;
      }

      facet-filters-form [data-paciocco-choices] input[type="checkbox"] {
        position: absolute !important;
        inset: 0 !important;
        width: 100% !important;
        height: 100% !important;
        margin: 0 !important;
        opacity: 0 !important;
        z-index: 1 !important;
        cursor: inherit !important;
      }

      facet-filters-form [data-paciocco-choices] label:has(input:checked) {
        background: #111 !important;
        border-color: #111 !important;
        color: #fff !important;
      }

      facet-filters-form [data-paciocco-choices] label:has(input:checked) .facet-checkbox__text,
      facet-filters-form [data-paciocco-choices] label:has(input:checked) .facet-checkbox__text-label {
        background: transparent !important;
        color: #fff !important;
      }

      facet-filters-form [data-paciocco-choices] label:has(input:focus-visible) {
        outline: 2px solid #111 !important;
        outline-offset: 2px !important;
      }

      facet-filters-form [data-paciocco-choices] label:has(input:disabled) {
        opacity: .4 !important;
        cursor: not-allowed !important;
      }

      #main-collection-filters .active-facets-mobile,
      #main-collection-filters .active-facets-desktop {
        display: flex !important;
        flex-wrap: wrap !important;
        align-items: center !important;
        gap: 8px !important;
        width: 100% !important;
        min-width: 0 !important;
        margin: 12px 0 !important;
        box-sizing: border-box !important;
      }

      #main-collection-filters .active-facets-mobile:empty,
      #main-collection-filters .active-facets-desktop:empty {
        display: none !important;
      }

      #main-collection-filters [data-paciocco-size-badges],
      #main-collection-filters [data-paciocco-size-badges] > span {
        display: contents !important;
      }

      #main-collection-filters .active-facets-mobile facet-remove,
      #main-collection-filters .active-facets-desktop facet-remove {
        display: block !important;
        min-width: 0 !important;
        max-width: 100% !important;
        padding: 0 !important;
        margin: 0 !important;
      }

      #main-collection-filters .active-facets-mobile .active-facets__button,
      #main-collection-filters .active-facets-desktop .active-facets__button {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        box-sizing: border-box !important;
        min-height: 36px !important;
        max-width: 100% !important;
        margin: 0 !important;
        padding: 8px 10px !important;
        border: 1px solid #d6d6d6 !important;
        border-radius: 2px !important;
        background: #f5f5f5 !important;
        color: #111 !important;
        font-size: 12px !important;
        line-height: 1.3 !important;
        text-decoration: none !important;
        box-shadow: none !important;
      }

      #main-collection-filters .active-facets-mobile .active-facets__button-inner,
      #main-collection-filters .active-facets-desktop .active-facets__button-inner {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 8px !important;
        min-width: 0 !important;
        min-height: 0 !important;
        height: auto !important;
        padding: 0 !important;
        margin: 0 !important;
        border: 0 !important;
        background: transparent !important;
        color: inherit !important;
        font: inherit !important;
        white-space: normal !important;
        overflow-wrap: anywhere;
        box-shadow: none !important;
      }

      #main-collection-filters .active-facets__button-inner .svg-wrapper {
        flex: 0 0 12px !important;
        width: 12px !important;
        height: 12px !important;
        margin: 0 !important;
      }

      #main-collection-filters .active-facets-mobile .active-facets__button-wrapper,
      #main-collection-filters .active-facets-desktop .active-facets__button-wrapper {
        flex-basis: 100% !important;
        order: 2 !important;
      }

      #main-collection-filters .active-facets-mobile .active-facets__button-remove,
      #main-collection-filters .active-facets-desktop .active-facets__button-remove {
        display: inline-flex !important;
        align-items: center !important;
        min-height: 32px !important;
        margin: 0 !important;
        padding: 0 !important;
        font-size: 12px !important;
        line-height: 1.3 !important;
      }

      @media (max-width: 1024px) {
        .active-facets-desktop {
          display: none !important;
        }

        .active-facets-mobile {
          padding: 0 10px !important;
        }
      }

      @media (min-width: 1025px) {
        .active-facets-mobile {
          display: none !important;
        }
      }

      facet-filters-form [data-paciocco-choices] > li.hidden,
      facet-filters-form [data-paciocco-choices] > li[hidden] {
        display: none !important;
      }

      facet-filters-form [data-paciocco-choices] label {
        transform: none !important;
        float: none !important;
      }

      facet-filters-form [data-paciocco-choices] .paciocco-choice-text {
        color: inherit !important;
      }

      facet-filters-form [data-paciocco-choices] label:has(input:checked) .paciocco-choice-text {
        color: #fff !important;
      }
    `;

    document.head.appendChild(style);

    formatFilterChoices();

    const initialParams = new URLSearchParams(
      window.location.search
    );

    if (
      selectedSizes(initialParams).length ||
      FacetFiltersForm.onlySoldOut(initialParams.toString())
    ) {
      FacetFiltersForm.renderPage(
        initialParams.toString(),
        null,
        false
      );
    } else {
      hydrateInitialSizes(initialParams);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {
      once: true
    });
  } else {
    start();
  }
})();

/* PACIOCCO — Un solo "Cancella tutto" per vista */
(() => {
  const patchId = 'paciocco-clear-all-fix';

  if (document.getElementById(patchId)) return;

  const style = document.createElement('style');
  style.id = patchId;

  style.textContent = `
    #main-collection-filters
    facet-remove[data-pc-clear-duplicate="true"] {
      display: none !important;
    }

    @media (max-width: 1024px) {
      #main-collection-filters .active-facets-desktop {
        display: none !important;
      }
    }

    @media (min-width: 1025px) {
      #main-collection-filters .active-facets-mobile {
        display: none !important;
      }
    }
  `;

  document.head.appendChild(style);

  let scheduled = false;

  function refreshClearAll() {
    const root = document.getElementById(
      'main-collection-filters'
    );

    if (!root) return;

    const groups = {
      page: [],
      drawer: []
    };

    root.querySelectorAll('facet-remove a').forEach(link => {
      const caption = link.textContent
        .replace(/\s+/g, ' ')
        .trim();

      if (
        !/^(cancella tutto|rimuovi tutti|clear all)$/i.test(caption)
      ) {
        return;
      }

      const owner = link.closest('facet-remove');
      if (!owner) return;

      owner.removeAttribute('data-pc-clear-duplicate');

      const group = link.closest('#FacetFiltersFormMobile')
        ? groups.drawer
        : groups.page;

      group.push({ owner, link });
    });

    Object.values(groups).forEach(entries => {
      const visible = entries.filter(({ owner }) => {
        return owner.getClientRects().length > 0
          && getComputedStyle(owner).visibility !== 'hidden';
      });

      const keep = visible.find(({ link }) => {
        return !link.closest('form');
      }) || visible[0];

      visible.forEach(entry => {
        if (entry === keep) return;

        entry.owner.setAttribute(
          'data-pc-clear-duplicate',
          'true'
        );
      });
    });
  }

  function scheduleRefresh() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      refreshClearAll();
    });
  }

  function start() {
    const root = document.getElementById(
      'main-collection-filters'
    );

    if (!root) return;

    refreshClearAll();

    const observer = new MutationObserver(scheduleRefresh);

    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open', 'class', 'hidden']
    });

    window.addEventListener('resize', scheduleRefresh);
    window.addEventListener('popstate', scheduleRefresh);

    root.addEventListener('click', scheduleRefresh);
    root.addEventListener('change', scheduleRefresh);
    root.addEventListener('toggle', scheduleRefresh, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {
      once: true
    });
  } else {
    start();
  }
})();